import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/AGBA/robo-illustration/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
